import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useState, useEffect } from "react";
import { editTicketStatus } from "../../api/tickets.api";
import styles from "../Overlay/Overlay.module.css"
import FieldForm from "../FieldForm";
import 'react-toastify/dist/ReactToastify.css';
import {
    SelectRoot,
    SelectTrigger,
    SelectContent,
    SelectItem
} from "../ui/select"
import { check } from "../../api/users.api";
import Overlay from "../Overlay";
import HeaderForm from "../HeaderForm";
import LabelRequired from "../LabelRequired";
import ButtonForm from "../ButtonForm";


function FormTicketEditStatus({ setIsOpen, thisTicket }) {


    const [status, setStatus] = useState("Pendente")
    const [descricao, setDescricao] = useState("")
    const [userData, setUserData] = useState({})

    useEffect(() => {
        check()
            .then(res => setUserData(res.data))
            .catch((error) => {
                if(error.response.status === 401) {
                   console.log("algo deu errado");
                }
            })
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const dataPrevisaoPartes = thisTicket.dataPrevisao.split("/")
         const dataPrevisaoFormatada = `${dataPrevisaoPartes[2]}-${dataPrevisaoPartes[1]}-${dataPrevisaoPartes[0]}T17:00:00`

        const dataAberturaPartes = thisTicket.dataAbertura.split("/")
        const dataAberturaFormatada = `${dataAberturaPartes[2]}-${dataAberturaPartes[1]}-${dataAberturaPartes[0]}T00:00:00`

        const ticketData = {
            Id: thisTicket.id,
            Custo: thisTicket.custo,
            DataPrevisao: dataPrevisaoFormatada,
            Oficina: thisTicket.oficina,
            CarId: thisTicket.car.id,
            Descricao: thisTicket.descricao,
            PontoDeVerificacao: thisTicket.pontoDeVerificacao,
            Status: status,
            Codigo: thisTicket.codigo,
            DataAbertura: dataAberturaFormatada,
            Descricao: thisTicket.descricao,
            ChecklistId: thisTicket.checklistId == 0 ? null : thisTicket.checklistId,
            QuantidadeOcorrencias: thisTicket.quantidadeOcorrencias,
            PrimeiraOcorrencia: null,
            UltimaOcorrencia: null
        }

        const interactionData = {
            User: userData.name,
            UserId: userData.id,
            Message: descricao,
            TicketId: thisTicket.id,
            Status: status
        }

        console.log({Ticket: ticketData, Interaction: interactionData})
    
        await editTicketStatus({Ticket: ticketData, Interaction: interactionData})
            .then(() => {
                setIsOpen(false);
                return toast.success("Interação realizada!")
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    return toast.error("Não autorizado!");
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }


    return (
       <Overlay>
            <form onSubmit={handleSubmit}>
                <HeaderForm 
                    title="Interagir no Ticket"
                    close={() => setIsOpen(false)}
                />
                <div className={styles.select}>
                    
                    <SelectRoot value={status} onValueChange={setStatus}>
                        <SelectTrigger />
                        <SelectContent>
                            <SelectItem value="Pendente">Pendente</SelectItem>
                            <SelectItem value="Agendada">Agendada</SelectItem>
                            <SelectItem value="Em Andamento">Em Andamento</SelectItem>
                        </SelectContent>
                    </SelectRoot>
                </div>

                <div className={styles.textarea}>
                    <LabelRequired>Mensagem</LabelRequired>
                    <textarea onChange={(e) => setDescricao(e.target.value)} placeholder="Digite sua mensagem..." >{descricao}</textarea>
                </div>

               <ButtonForm>Salvar</ButtonForm>
            </form >
        
        </Overlay>
    )
}

export default FormTicketEditStatus;